import { Swiper } from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

common.View.create('story::canvas.blocks.modules.storySlider.Block', {

    onDOMLoad()
    {
        this.initSlider();
    },

    initSlider()
    {
        const swiperElement = this.element.find('.swiper-container');
        const nextButton = this.element.find('.swiper-button-next').get(0);

        if (!swiperElement.length || !nextButton) {
            return;
        }

        new Swiper(swiperElement.get(0), {
            modules: [Navigation, Autoplay],
            loop: false,
            spaceBetween: 20,
            slidesPerView: 1,
            navigation: {
                nextEl: nextButton,
            },
            autoplay: false,
            // Responsive breakpoints
            breakpoints: {
                // when window width is >= 640px
                640: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                // when window width is >= 1024px
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 50,
                }
            }
        });
    }
});
